import AddToList from "./addToList";
import ActivityIndicator from "./activityIndicator";
import Anchor from "./anchor";
import ArrowBottomLeft from "./arrowBottomLeft";
import ArrowBottomRight from "./arrowBottomRight";
import ArrowDown from "./arrowDown";
import ArrowLeft from "./arrowLeft";
import ArrowRight from "./arrowRight";
import ArrowTopLeft from "./arrowTopLeft";
import ArrowTopRight from "./arrowTopRight";
import ArrowUp from "./arrowUp";
import Attachment from "./attachment";
import Audio from "./audio";
import AvailableSeats from "./availableSeats";
import B2B from "./b2b";
import B2C from "./b2c";
import B2CBigger from "./b2cBigger";
import Back from "./back";
import Backwards from "./backwards";
import Backwards5 from "./backwards5";
import BathPlanner from "./3dBathPlanner";
import BathroomProducts from "./bathroomProducts";
import Battery from "./battery";
import BLE from "./BLE";
import BMS from "./BMS";
import BreadcrumbArrow from "./breadcrumbArrow";
import BreadcrumbHome from "./breadcrumbHome";
import BrightnessMax from "./brightnessMax";
import BrightnessMin from "./brightnessMin";
import Bullet from "./bullet";
import Calendar from "./calendar";
import Catalogue from "./catalogue";
import Categories from "./categories";
import CellularNetwork from "./cellularNetwork";
import Chat from "./chat";
import Checklist from "./checklist";
import Checkmark from "./checkmark";
import ChevronDown from "./chevronDown";
import ChevronDownFilled from "./chevronDownFilled";
import ChevronFlatDown from "./chevronFlatDown";
import ChevronFlatLeft from "./chevronFlatLeft";
import ChevronFlatRight from "./chevronFlatRight";
import ChevronFlatUp from "./chevronFlatUp";
import ChevronLeft from "./chevronLeft";
import ChevronRight from "./chevronRight";
import ChevronUp from "./chevronUp";
import ChevronUpFilled from "./chevronUpFilled";
import Cleaning from "./cleaning";
import Clock from "./clock";
import Close from "./close";
import Cloud from "./cloud";
import Collect from "./collect";
import Compare from "./compare";
import ContactForm from "./contactForm";
import ContentCopy from "./contentCopy";
import ContentPaste from "./contentPaste";
import CostPerPerson from "./costPerPerson";
import CreateGroupe from "./createGroupe";
import Data from "./3dData";
import Datapoints from "./datapoints";
import Descaling from "./descaling";
import Disk from "./disk";
import DoubleChevronDown from "./doubleChevronDown";
import DoubleChevronFlatDown from "./doubleChevronFlatDown";
import DoubleChevronFlatLeft from "./doubleChevronFlatLeft";
import DoubleChevronFlatRight from "./doubleChevronFlatRight";
import DoubleChevronFlatUp from "./doubleChevronFlatUp";
import DoubleChevronLeft from "./doubleChevronLeft";
import DoubleChevronRight from "./doubleChevronRight";
import DoubleChevronUp from "./doubleChevronUp";
import Download from "./download";
import DownloadBook from "./downloadBook";
import Duration from "./duration";
import Edit from "./edit";
import EmptyPipe from "./emptyPipe";
import Envelope from "./envelope";
import Error1 from "./error1";
import Error2 from "./error2";
import Ethernet from "./ethernet";
import Excel from "./excel";
import ExitFullscreen from "./exitFullscreen";
import Export from "./export";
import ExternalLink from "./externalLink";
import Eye from "./eye";
import EyeHide from "./eyeHide";
import Facebook from "./facebook";
import FailedConnection from "./failedConnection";
import Fan from "./fan";
import FanMax from "./fanMax";
import FanMin from "./fanMin";
import File from "./file";
import FileWithType from "./fileWithType";
import Filter from "./filter";
import Flipbook from "./flipbook";
import Flush from "./flush";
import FlushOff from "./flushOff";
import Folder from "./folder";
import Forwards from "./forwards";
import Forwards5 from "./forwards5";
import Fullscreen from "./fullscreen";
import Functions from "./functions";
import GalleryView from "./galleryView";
import Gas from "./gas";
import Gateway from "./gateway";
import Gbus from "./Gbus";
import Geberitconnect from "./geberitconnect";
import GeberitID from "./geberitID";
import Globe from "./globe";
import GroupAction from "./groupAction";
import HardDrive from "./hardDrive";
import Headset from "./headset";
import Heating from "./heating";
import Help from "./help";
import Home from "./home";
import HovericonHoverImage from "./hovericonHoverImage";
import IDC from "./IDC";
import IDCGbus from "./IDCGbus";
import IDCGbusPowersupply from "./IDCGbusPowersupply";
import Import from "./import";
import Industry from "./industry";
import Info from "./info";
import InfoCircleFull from "./infoCircleFull";
import InfoCircleFullBlue from "./infoCircleFullBlue";
import InfoCircleOutline from "./infoCircleOutline";
import Information from "./information";
import Inspiraton from "./inspiration";
import Inspirator from "./inspirator";
import Instagram from "./instagram";
import InstallationSystems from "./installationSystems";
import ListView from "./listView";
import LensZoomIn from "./lensZoomIn";
import LensZoomOut from "./lensZoomOut";
import Lightbulb from "./lightbulb";
import Linkedin from "./linkedin";
import Location from "./location";
import LogOut from "./logOut";
import Lock from "./lock";
import Manual from "./manual";
import MarkerHotelPin from "./markerHotelPin";
import MarkerPin from "./markerPin";
import Menu from "./menu";
import Minus from "./minus";
import Mobiledevice from "./mobiledevice";
import More from "./more";
import MoreActive from "./moreActive";
import MorePagination from "./morePagination";
import MoveToFolder from "./moveToFolder";
import Movie from "./movie";
import MP3 from "./mp3";
import MP4 from "./mp4";
import NavBathroomSystems from "./navBathroomSystems";
import NavCollections from "./navCollections";
import NavDrainageSystems from "./navDrainageSystems";
import NavInstallation from "./navInstallation";
import NavSupplySystems from "./navSupplySystems";
import NavTools from "./navTools";
import New from "./new";
import Newsletter from "./newsletter";
import Onlineshop from "./onlineshop";
import OpenBook from "./openBook";
import OpenCamera from "./openCamera";
import Options from "./options";
import Pause from "./pause";
import Pdf from "./pdf";
import Pen from "./pen";
import PencilFilled from "./pencilFilled";
import Picture from "./picture";
import Pinterest from "./pinterest";
import Play from "./play";
import Plus from "./plus";
import Presets from "./presets";
import Printer from "./printer";
import Profile from "./profile";
import Redo from "./redo";
import Refresh from "./refresh";
import Reload from "./reload";
import Remote from "./remote";
import RemoteMaintenance from "./remoteMaintenance";
import Save from "./save";
import Search from "./search";
import SearchDocument from "./searchDocument";
import Security from "./security";
import Select from "./select";
import SelectOff from "./selectOff";
import SelectOn from "./selectOn";
import Sensor from "./sensor";
import SensorMax from "./sensorMax";
import SensorMin from "./sensorMin";
import Service from "./service";
import ServiceChat from "./serviceChat";
import ServiceFax from "./serviceFax";
import ServicePinOutline from "./servicePinOutline";
import Settings from "./settings";
import Share from "./share";
import Shipbuilding from "./shipbuilding";
import Smartphone from "./smartphone";
import Spinner from "./spinner";
import Sprinkler from "./sprinkler";
import Stats from "./stats";
import Stethoscope from "./stethoscope";
import Stop from "./stop";
import Tap from "./tap";
import Targetgroup from "./targetgroup";
import Telephone from "./telephone";
import Temperature from "./temperature";
import TemperatureDown from "./temperatureDown";
import TemperatureUp from "./temperatureUp";
import ThumbsDown from "./thumbsDown";
import ThumbsUp from "./thumbsUp";
import ToiletControl from "./toiletControl";
import Tools from "./tools";
import Trash from "./trash";
import Twitter from "./twitter";
import UnderfloorHeating from "./underfloorHeating";
import Undo from "./undo";
import UnknownProduct from "./unknownProduct";
import Update from "./update";
import Upload from "./upload";
import Urinal from "./urinal";
import UserLoggedOff from "./userLoggedOff";
import UserLoggedOn from "./userLoggedOn";
import Viewer from "./3dViewer";
import VolumeLouder from "./volumeLouder";
import VolumeMute from "./volumeMute";
import VolumeQuieter from "./volumeQuieter";
import WarningModearte from "./warningModearte";
import WarningSevere from "./warningSevere";
import Watchlist from "./watchlist";
import WatchlistAdd from "./watchlistAdd";
import WatchlistAdded from "./watchlistAdded";
import Water from "./water";
import WebApplication from "./webApplication";
import WIFI from "./WIFI";
import Wired from "./wired";
import Wireless from "./wireless";
import Xing from "./xing";
import Youtube from "./youtube";
import Zip from "./zip";
import ZoomIn from "./zoomIn";
import ZoomOut from "./zoomOut";
import AquaClean from "./aquaClean";
import ReturnGoods from "./returnGoods";
import SanitaryFlush from "./sanitaryFlush";
import Bookmark from "./bookMark";
import BookmarkActive from "./bookMarkActive";
import Favourite from "./favourite";
import FavouriteActive from "./favouriteActive";
import ThumbsUpActive from "./thumbsUpActive";
import ThumbsDownActive from "./thumbsDownActive";
import Cut from "./cut";
import Send from "./send";
import ActuatorRectangular from "./actuator";
import DuofreshSticks from "./duofreshStick";
import Individual from "./individual";
import Touchless from "./touchless";
import DragDrop from "./dragDrop";
import Enter from "./enter";
import Lists from "./lists";
import Link from "./link";
import MoreSmall from "./moreSmall";
import PartialMatchCheck from "./partialMatchCheck";
import ProductImages from "./productImages";
import Relation from "./relation";
import SampleCatalogue from "./sampleCatalogue";
import ServiceDirectory from "./serviceDirectory";
import Image from "./image";
import Document from "./document";
import TechnicalDrawing from "./technicalDrawing";
import WhatsApp from "./whatsApp";
import Log from "./log";
import Csv from "./csv";
import GeBus from "./ge-bus";
import BatteryFull from "./battery-full";
import BatteryOk from "./battery-ok";
import BatteryLow from "./battery-low";
import BatteryEmpty from "./battery-empty";
import Converter from "./converter";
import Reset from "./reset";
import FlushMax from "./flush-max";
import FlushMin from "./flush-min";
export const icons = {
    BatteryFull,
    BatteryOk,
    BatteryLow,
    BatteryEmpty,
    Converter,
    Reset,
    FlushMax,
    FlushMin,
    GeBus,
    Csv,
    WhatsApp,
    TechnicalDrawing,
    Data,
    Categories,
    ActuatorRectangular,
    DuofreshSticks,
    Individual,
    Touchless,
    Inspiraton,
    ActivityIndicator,
    AddToList,
    Anchor,
    ArrowDown,
    AquaClean,
    ArrowBottomLeft,
    ArrowBottomRight,
    ArrowLeft,
    ArrowRight,
    ArrowTopLeft,
    ArrowTopRight,
    ArrowUp,
    Attachment,
    Audio,
    AvailableSeats,
    B2B,
    B2C,
    B2CBigger,
    Back,
    Backwards,
    Backwards5,
    BathPlanner,
    BathroomProducts,
    Battery,
    BLE,
    BMS,
    BreadcrumbArrow,
    BreadcrumbHome,
    BrightnessMax,
    BrightnessMin,
    Bookmark,
    BookmarkActive,
    Bullet,
    Calendar,
    Catalogue,
    CellularNetwork,
    Chat,
    Checklist,
    Checkmark,
    ChevronDown,
    ChevronDownFilled,
    ChevronFlatDown,
    ChevronFlatLeft,
    ChevronFlatRight,
    ChevronFlatUp,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronUpFilled,
    Cleaning,
    Clock,
    Close,
    Cloud,
    Collect,
    Compare,
    ContactForm,
    ContentCopy,
    ContentPaste,
    CostPerPerson,
    CreateGroupe,
    Cut,
    Datapoints,
    Descaling,
    Disk,
    Document,
    DoubleChevronDown,
    DoubleChevronFlatDown,
    DoubleChevronFlatLeft,
    DoubleChevronFlatRight,
    DoubleChevronFlatUp,
    DoubleChevronLeft,
    DoubleChevronRight,
    DoubleChevronUp,
    Download,
    DownloadBook,
    Duration,
    DragDrop,
    Edit,
    EmptyPipe,
    Enter,
    Envelope,
    Error1,
    Error2,
    Ethernet,
    Excel,
    ExitFullscreen,
    Export,
    ExternalLink,
    Eye,
    EyeHide,
    Facebook,
    FailedConnection,
    Fan,
    FanMax,
    FanMin,
    Favourite,
    FavouriteActive,
    File,
    FileWithType,
    Filter,
    Flipbook,
    Flush,
    FlushOff,
    Folder,
    Forwards,
    Forwards5,
    Fullscreen,
    Functions,
    GalleryView,
    Gas,
    Gateway,
    Gbus,
    Geberitconnect,
    GeberitID,
    Globe,
    GroupAction,
    HardDrive,
    Headset,
    Heating,
    Help,
    Home,
    HovericonHoverImage,
    IDC,
    IDCGbus,
    IDCGbusPowersupply,
    Image,
    Import,
    Industry,
    Info,
    InfoCircleFull,
    InfoCircleFullBlue,
    InfoCircleOutline,
    Information,
    Inspirator,
    Instagram,
    InstallationSystems,
    Lists,
    ListView,
    LensZoomIn,
    LensZoomOut,
    Lightbulb,
    Link,
    Linkedin,
    Location,
    Lock,
    Log,
    LogOut,
    Manual,
    MarkerHotelPin,
    MarkerPin,
    Menu,
    Minus,
    Mobiledevice,
    More,
    MoreActive,
    MorePagination,
    MoreSmall,
    MoveToFolder,
    Movie,
    MP3,
    MP4,
    NavBathroomSystems,
    NavCollections,
    NavDrainageSystems,
    NavInstallation,
    NavSupplySystems,
    NavTools,
    New,
    Newsletter,
    Onlineshop,
    OpenBook,
    Options,
    PartialMatchCheck,
    Pause,
    Pdf,
    Pen,
    PencilFilled,
    Picture,
    Pinterest,
    Play,
    Plus,
    Presets,
    Printer,
    ProductImages,
    Profile,
    Redo,
    Refresh,
    Relation,
    Reload,
    Remote,
    RemoteMaintenance,
    ReturnGoods,
    Save,
    SanitaryFlush,
    SampleCatalogue,
    Search,
    SearchDocument,
    Security,
    Select,
    SelectOff,
    SelectOn,
    Send,
    Sensor,
    SensorMax,
    SensorMin,
    Service,
    ServiceChat,
    ServiceDirectory,
    ServiceFax,
    ServicePinOutline,
    Settings,
    Share,
    Shipbuilding,
    Smartphone,
    Spinner,
    Sprinkler,
    Stats,
    Stethoscope,
    OpenCamera,
    Stop,
    Tap,
    Targetgroup,
    Telephone,
    Temperature,
    TemperatureDown,
    TemperatureUp,
    ThumbsDown,
    ThumbsDownActive,
    ThumbsUp,
    ThumbsUpActive,
    ToiletControl,
    Tools,
    Trash,
    Twitter,
    UnderfloorHeating,
    Undo,
    UnknownProduct,
    Update,
    Upload,
    Urinal,
    UserLoggedOff,
    UserLoggedOn,
    Viewer,
    VolumeLouder,
    VolumeMute,
    VolumeQuieter,
    WarningModearte,
    WarningSevere,
    Watchlist,
    WatchlistAdd,
    WatchlistAdded,
    Water,
    WebApplication,
    WIFI,
    Wired,
    Wireless,
    Xing,
    Youtube,
    Zip,
    ZoomIn,
    ZoomOut,
};
export default icons;
